import axios from 'axios';
const PUBLIC_ROOT = '/public';
export default {
	getRealEstateDataById(id) {
		return axios.get(`${PUBLIC_ROOT}/properties/${id}`);
	},
	getAgent(id) {
		return axios.get(`${PUBLIC_ROOT}/agents-and-offices/agents/${id}`);
	}
};
